/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ source: NonNullable<unknown> }} Import_From_ClipboardInputs */

const en_import_from_clipboard = /** @type {(inputs: Import_From_ClipboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pasted from clipboard · ${i?.source}`)
};

const de_import_from_clipboard = /** @type {(inputs: Import_From_ClipboardInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aus der Zwischenablage · ${i?.source}`)
};

/**
* | output |
* | --- |
* | "Pasted from clipboard · {source}" |
*
* @param {Import_From_ClipboardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_from_clipboard = /** @type {((inputs: Import_From_ClipboardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_From_ClipboardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_from_clipboard(inputs)
	return en_import_from_clipboard(inputs)
});